import { render, staticRenderFns } from "./PasswordEditor.vue?vue&type=template&id=95a7d5ce"
import script from "./PasswordEditor.vue?vue&type=script&lang=ts"
export * from "./PasswordEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports